export default __webpack_public_path__ + "static/media/fillrock-rg-plus_comp.5b1c0734.jpg";